var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({ cursor: _vm.coloredCursor})},[(_vm.requiresAuth)?_c('SessionTimeoutModal'):_vm._e(),_c('Notifications'),_c('Modals'),_c(_vm.layout,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }